import { createClient } from "@supabase/supabase-js";

// La clé anon est publique : elle ne donne accès qu'à ce que les règles
// RLS de la base autorisent pour chaque utilisateur connecté.
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Si les variables ne sont pas configurées, on exporte null et l'UI affiche
// un message propre plutôt que de planter.
export const supabase =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
      })
    : null;

export const isSupabaseReady = Boolean(supabase);
